"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACSkeleton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react/react-in-jsx-scope */
var ACSkeleton = function (props) {
    return ((0, jsx_runtime_1.jsx)("div", { className: (props === null || props === void 0 ? void 0 : props.containerClassName) || '', children: (0, jsx_runtime_1.jsx)("span", { className: "apx-ui-shimmer-effect w-full ".concat(props === null || props === void 0 ? void 0 : props.className) }) }));
};
exports.ACSkeleton = ACSkeleton;
